<template>
  <div class="content">
        <h1>Privacy Policy</h1>
        <p><strong>Effective Date:</strong> May 21, 2025</p>
        <p><strong>App Name:</strong> Bantuek</p>
        <p><strong>Contact Email:</strong> chanon.manojit@hotmail.com</p>

        <h2>1. Introduction</h2>
        <p>
            This Privacy Policy explains how Bantuek ("we", "our", or "us") collects, uses, and protects your personal information when you use our mobile application.
        </p>

        <h2>2. Information We Collect</h2>
        <p>
            We only collect the following personal information from users who log in to the app via Firebase Authentication using Apple ID or Google Account:
        </p>
        <ul>
            <li>Email address</li>
            <li>First name</li>
            <li>Last name</li>
            <li>Subscription status and plan</li>
        </ul>
        <p>
            We do not collect your date of birth, age, or any other personally identifying information.
        </p>

        <h2>3. How We Use Your Information</h2>
        <p>Your data is used strictly for the following purposes:</p>
        <ul>
            <li>To identify and authenticate you with the app</li>
            <li>To determine your current subscription plan and grant appropriate access</li>
        </ul>

        <h2>4. Third-Party Services</h2>
        <p>
            We use the following third-party services that may collect or process user data in accordance with their own privacy policies:
        </p>
        <ul>
            <li>Firebase Authentication (Google)</li>
            <li>RevenueCat (manages subscription status and App Store billing)</li>
            <li>Google Analytics (tracks app usage behavior in aggregate, for improvement purposes)</li>
            <li>Apple App Store (processes payments and stores related billing information)</li>
        </ul>
        <p>
            We do not sell or share your personal data with unrelated third parties.
        </p>

        <h2>5. Data Retention</h2>
        <p>
            Your personal data is stored securely and retained only as long as your account is active, or as required by law. You may request account deletion at any time via our contact email.
        </p>

        <h2>6. Children’s Privacy</h2>
        <p>
            Bantuek does not knowingly collect or solicit data from children under the age of 13. If you believe we have unknowingly collected such data, please contact us immediately.
        </p>

        <h2>7. Your Rights</h2>
        <p>You may request to:</p>
        <ul>
            <li>Access your stored data</li>
            <li>Correct or delete your personal data</li>
            <li>Opt out of analytics tracking</li>
            <li>Delete your account</li>
        </ul>
        <p>
            Please contact us at <a href="mailto:chanon.manojit@hotmail.com">chanon.manojit@hotmail.com</a> to make any such request.
        </p>

        <h2>8. Changes to This Privacy Policy</h2>
        <p> We may update this Privacy Policy occasionally. We will notify users by updating the “Effective Date” at the top of this document. </p>

        <h2>9. Contact Us</h2>
        <p>
            If you have any questions about this Privacy Policy or your data, please contact us at:<br>
            📧 <a href="mailto:chanon.manojit@hotmail.com">chanon.manojit@hotmail.com</a>
        </p>
    </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style lang="scss" scoped>
.content {
    // padding: 0rem 5rem;
    animation: moveInBottom .5s ease-out .1s;
    animation-fill-mode: backwards;
    .img {
        margin-top: 1rem;
        width: 50%;
    }
    .img-hor {
        display: flex;
        flex-direction: column;
    }
}
</style>